import { Inject, Injectable, PLATFORM_ID } from '@angular/core';

import * as fromRoot from '@app/reducers';
import { Store, select } from '@ngrx/store';
import { Observable, ReplaySubject, of } from 'rxjs';
import { distinctUntilChanged, map, withLatestFrom } from 'rxjs/operators';
import { AccountActions } from '../../actions';
import { TokenService } from '../../services/token.service';
import { GoogleTagManagerService } from '@app/core/lib/google-tag-manager/angular-google-tag-manager.service';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class IsAccountValidGuard {

  constructor(
    private store$: Store<fromRoot.State>,
    private gtmService: GoogleTagManagerService,
    private tokenService: TokenService,
    @Inject(PLATFORM_ID) private platformId: object) {
  }

  canActivate(): Observable<boolean> {
    if (isPlatformServer(this.platformId)) {
      return of(true);
    }
    return this.isAccountValid().pipe(map((accountIsValid: boolean) => {
      return accountIsValid;
    }));
  }

  isAccountValid(): Observable<boolean> {
    const isAccountValid$ = new ReplaySubject<boolean>();
    this.store$.pipe(
      select(fromRoot.getToken),
      withLatestFrom(
        this.store$.select(fromRoot.getCurrentRegion),
        this.store$.select(fromRoot.getActiveIdentityUpdating),
      ),
      distinctUntilChanged(),
    ).subscribe(([token, region, tokenUpdating]) => {
      if (token) {
        if (this.tokenService.isTokenExpired(token)) {
          this.store$.dispatch(AccountActions.refreshToken());
        } else if (this.tokenService.isAnonymousAccount(token) && this.tokenService.getRegionFromToken(token) !== region) {
          this.store$.dispatch(AccountActions.createUserAnonymous());
        } else {
          if (isPlatformBrowser(this.platformId)) {
            this.gtmService.addGtmToDom();
          }
          isAccountValid$.next(true);
        }
      } else if (!token && !tokenUpdating) {
        this.store$.dispatch(AccountActions.createUserAnonymous());
      }
    });
    return isAccountValid$.asObservable();
  }
}

